<div class="atp">
  <header class="atp-head">
    <button type="button" class="atp-close" (click)="cancel()" aria-label="Close">
      <i class="bx bx-x" aria-hidden="true"></i>
    </button>
    <h2 class="atp-title">Add Category to {{ type?.name || 'Type' }}</h2>
    <div class="atp-actions">
      <button type="button" class="atp-cancel" (click)="cancel()">Cancel</button>
      <button type="button" class="atp-save" [disabled]="!name.trim()" (click)="save()">
        Save Category
      </button>
    </div>
  </header>

  <div class="atp-body">
    <section class="atp-card">
      <header class="atp-card-head">
        <span class="atp-card-icon"><i class="bx bx-plus" aria-hidden="true"></i></span>
        <h3 class="atp-card-title">Category Details</h3>
      </header>

      <label class="atp-label" for="categoryName">Category Name *</label>
      <input
        id="categoryName"
        class="atp-input"
        type="text"
        autocomplete="off"
        placeholder="e.g. Spanish"
        [(ngModel)]="name"
        (ngModelChange)="error = ''"
        [class.input-error]="!!error"
      />
      @if (error) {
        <div class="d-flex mt-2 errorText gap-2">
          <mat-icon svgIcon="warning-icon" class="warning-icon"></mat-icon>
          <p>{{ error }}</p>
        </div>
      }

      <label class="atp-label atp-label--spaced" for="categoryDescription">Description</label>
      <textarea
        id="categoryDescription"
        class="atp-input atp-textarea"
        rows="3"
        [placeholder]="
          'Dishes originating from ' + (type?.name || 'this type') + ' traditions (optional)'
        "
        [(ngModel)]="description"
      ></textarea>
    </section>

    @if (existingCategories.length) {
      <section class="atp-card">
        <span class="atp-eyebrow">Existing categories in {{ type?.name }}</span>
        <div class="atp-existing">
          @for (category of existingCategories; track category.id || category.name) {
            <span class="atp-existing-chip">{{ category.name }}</span>
          }
        </div>
      </section>
    }
  </div>
</div>
